import ImageFormat$1 from '@finn-no/troika-react-image-format';
import React, { useMemo } from 'react';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function concatCdnUrl(cdnUrl, size, url) {
  if (cdnUrl === void 0) {
    cdnUrl = '';
  }

  return cdnUrl + "/dynamic/" + size + "/" + url;
}

var useImageSrcSet = function useImageSrcSet(_ref) {
  var format = _ref.format,
      cdnUrl = _ref.cdnUrl,
      url = _ref.url,
      width = _ref.width,
      height = _ref.height;
  var validWidthToSizes = useMemo(function () {
    // @TODO this branch is to fix a typing problem, the old function didn't handle undefined width or height and always returned an empty array
    //       before this can be fixed we need to check what the consequences are from returning a srcSet where we previously didn't
    if (!width || !height) {
      return [];
    }

    return format.widthToSizes.filter(function (_ref2) {
      var _formatWidth = _ref2[0];
      var formatWidth = parseInt(_formatWidth);

      if (format.key === '1by1') {
        return formatWidth <= width && formatWidth <= height;
      } else {
        return formatWidth <= width;
      }
    });
  }, [format, height, width]);
  var src = useMemo(function () {
    var size = '640w';

    if (validWidthToSizes && validWidthToSizes.length > 0) {
      size = validWidthToSizes[0][1];
    }

    return concatCdnUrl(cdnUrl, size, url);
  }, [cdnUrl, url, validWidthToSizes]);
  var srcSet = useMemo(function () {
    return validWidthToSizes.map(function (_ref3) {
      var width = _ref3[0],
          size = _ref3[1];
      return concatCdnUrl(cdnUrl, size, url) + " " + width;
    }).join(',\n');
  }, [cdnUrl, url, validWidthToSizes]);
  return {
    src: src,
    srcSet: srcSet
  };
};
var useFormat = function useFormat(_ref4) {
  var height = _ref4.height,
      width = _ref4.width;
  var format = useMemo(function () {
    if (!width || !height) {
      return getUncroppedFormat();
    } else if (width / height <= 0.76) {
      return getPortraitFormat();
    } else if (width / height >= 1.29) {
      return getLandscapeFormat();
    } else {
      return getSquareFormat();
    }
  }, [width, height]);
  return format;
};

function getUncroppedFormat() {
  return {
    key: '4by3',
    widthToSizes: [['480w', '480w'], ['240w', '240w'], ['320w', '320w'], ['640w', '640w'], ['960w', '960w']]
  };
}

function getPortraitFormat() {
  return {
    key: '3by4',
    widthToSizes: [['480w', '480x640c'], ['240w', '240x320c'], ['360w', '360x480c'], ['720w', '720x960c']]
  };
}

function getLandscapeFormat() {
  return {
    key: '4by3',
    widthToSizes: [['480w', '480x360c'], ['240w', '240x180c'], ['360w', '360x270c'], ['720w', '720x540c']]
  };
}

function getSquareFormat() {
  return {
    key: '1by1',
    widthToSizes: [['480w', '480x480c'], ['240w', '240x240c'], ['360w', '360x360c'], ['720w', '720x720c']]
  };
}

var AutoImageFormat$1 = function AutoImageFormat(props) {
  var width = props.width,
      height = props.height,
      url = props.url,
      cdnUrl = props.cdnUrl,
      _props$sizes = props.sizes,
      sizes = _props$sizes === void 0 ? '(min-width: 990px) 330px, (min-width: 768px) 33vw, (min-width: 480px) 50vw' : _props$sizes,
      imageFormatProps = _objectWithoutPropertiesLoose(props, ["width", "height", "url", "cdnUrl", "sizes"]);

  var format = useFormat({
    width: width,
    height: height
  });

  var _useImageSrcSet = useImageSrcSet({
    cdnUrl: cdnUrl,
    format: format,
    height: height,
    url: url,
    width: width
  }),
      src = _useImageSrcSet.src,
      srcSet = _useImageSrcSet.srcSet;

  return /*#__PURE__*/React.createElement(ImageFormat$1, _extends({}, imageFormatProps, {
    height: height,
    width: width,
    sizes: sizes,
    src: src,
    srcSet: srcSet,
    ratio: format.key
  }));
};

AutoImageFormat$1.displayName = "AutoImageFormat";

var SquareImageFormat = function SquareImageFormat(props) {
  var width = props.width,
      height = props.height,
      url = props.url,
      cdnUrl = props.cdnUrl,
      _props$sizes = props.sizes,
      sizes = _props$sizes === void 0 ? '(min-width: 990px) 330px, (min-width: 768px) 33vw, (min-width: 480px) 50vw' : _props$sizes,
      imageFormatProps = _objectWithoutPropertiesLoose(props, ["width", "height", "url", "cdnUrl", "sizes"]);

  var format = useMemo(function () {
    return getSquareFormat();
  }, []);

  var _useImageSrcSet = useImageSrcSet({
    cdnUrl: cdnUrl,
    format: format,
    height: height,
    url: url,
    width: width
  }),
      src = _useImageSrcSet.src,
      srcSet = _useImageSrcSet.srcSet;

  return /*#__PURE__*/React.createElement(ImageFormat$1, _extends({}, imageFormatProps, {
    width: width,
    height: height,
    sizes: sizes,
    src: src,
    srcSet: srcSet,
    ratio: format.key
  }));
};

SquareImageFormat.displayName = "SquareImageFormat";

var LogoImageFormat$1 = function LogoImageFormat(props) {
  var cdnUrl = props.cdnUrl,
      url = props.url,
      className = props.className,
      imageProps = _objectWithoutPropertiesLoose(props, ["cdnUrl", "url", "className"]);

  if (props.height && props.width) {
    imageProps.crop = props.height > props.width ? 'horizontal' : 'vertical';
  }

  return /*#__PURE__*/React.createElement(ImageFormat$1, _extends({}, imageProps, {
    src: concatCdnUrl(cdnUrl, '480w', url),
    className: classNames(className, 'u-bg-milk'),
    ratio: "1by1",
    type: "logo",
    centered: true
  }));
};

LogoImageFormat$1.displayName = "LogoImageFormat";

var AutoImageFormat = AutoImageFormat$1;
var SquareAutoImageFormat = SquareImageFormat;
var LogoImageFormat = LogoImageFormat$1; // @TODO it's pointless to re-export this package here instead of userland using it directly

var ImageFormat = ImageFormat$1;

export { AutoImageFormat, ImageFormat, LogoImageFormat, SquareAutoImageFormat };
//# sourceMappingURL=index.es.js.map
